<template>
  <div>
    <heading>{{ $t("sidebar.reports") }}</heading>

    <div v-if="ready">
      <v-tabs v-model="activeTab" class="mb-4">
        <v-tab href="#statistics">
          {{ $t("reports.tabs.statistics") }}
        </v-tab>
        <v-tab v-for="tab in availableTabs" :key="tab.key" :href="`#${tab.key}`">
          {{ $t(tab.label) }}
        </v-tab>
      </v-tabs>

      <div class="mt-2">
        <reportsStatistics
          v-if="activeTab === 'statistics'"
          :tabs="availableTabs"
          @open="goToTab"
        />
        <medkitlogYears v-else-if="activeTab === 'medkitlog'" />
        <incidentReportYears v-else-if="activeTab === 'incidentReport'" />
        <environmentalReportYears
          v-else-if="activeTab === 'environmentalReport'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import reportsStatistics from "./reportsStatistics.vue";
import { homePath } from "@/utils/access";
import medkitlogYears from "@/views/medkitlog/medkitlogYears.vue";
import incidentReportYears from "@/views/incidentReport/incidentReportYears.vue";
import environmentalReportYears from "@/views/environmentalReport/environmentalReportYears.vue";

const TAB_DEFS = [
  {
    key: "medkitlog",
    permission: "medkitlog",
    label: "sidebar.medkitlogs",
    icon: "local_hospital",
    statsAction: "getMedkitlogStats",
  },
  {
    key: "incidentReport",
    permission: "incidentreport",
    label: "sidebar.incidentReports",
    icon: "personal_injury",
    statsAction: "getIncidentReportStats",
  },
  {
    key: "environmentalReport",
    permission: "environmentalreport",
    label: "sidebar.environmentalReports",
    icon: "mdi-leaf",
    statsAction: "getEnvironmentalReportStats",
  },
];

export default {
  name: "reportsHub",
  components: {
    reportsStatistics,
    medkitlogYears,
    incidentReportYears,
    environmentalReportYears,
  },
  data() {
    return {
      permissions: [],
      ready: false,
      activeTab: null,
    };
  },
  computed: {
    availableTabs() {
      return TAB_DEFS.filter((tab) =>
        this.permissions.includes(tab.permission),
      );
    },
  },
  async created() {
    const { permissions } = await this.$store.dispatch("getUserInfo");
    this.permissions = permissions || [];

    if (!this.availableTabs.length) {
      this.$router.replace({ path: homePath() });
      return;
    }

    const requested = this.$route.query.tab;
    const allowed =
      requested === "statistics" ||
      this.availableTabs.some((tab) => tab.key === requested);
    this.activeTab = allowed ? requested : "statistics";

    this.ready = true;
  },
  methods: {
    goToTab(key) {
      this.activeTab = key;
    },
  },
  watch: {
    activeTab(tab) {
      if (tab && this.$route.query.tab !== tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      }
    },
  },
};
</script>
